import React from 'react'

import Translator from 'bazinga-translator'

import { PrimaryBadge } from './styles'

export function JackpotBadge() {
  return <PrimaryBadge>{Translator.trans('gameWithJackpot', {}, 'games')}</PrimaryBadge>
}
